import "./AboutUs.module.css";
import Navigation from "@/reusable_sections/Header";
import Philosophy from "./sections/Philosophy";
import BudsysStats from "./sections/BudsysStats";
import Team from "./sections/Team";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Navigation />
      <Philosophy />
      <BudsysStats />
      <Team />
      <Footer />
    </div>;
}